import { Layout, Typography } from "antd";
import { BindCompaniesView } from "features/bind-companies";
import { useTranslation } from "react-i18next";
import { AuthHeader } from "widgets/headers";

export const BindCompaniesPage = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "7vh",
        }}
        className="auth-layout-content"
      >
        <Typography.Title level={3}>
          {t("bind_companies.bind_title")}
        </Typography.Title>

        <BindCompaniesView />
      </Layout.Content>
    </Layout>
  );
};
